module.exports = __webpack_public_path__ + "static/media/half-circle.fa23a08f.svg";